import { forwardRef } from 'react';

import { useCurrentTheme } from '../../../core/hooks/useCurrentTheme.js';
import { useVisualPresetCdnUrl } from '../empty-state-utils.js';
import type { EmptyStateVisualPresetProps } from '../types/empty-state-types.js';

/**
 * Container for the Visual slot of the EmptyState component.
 * @public
 */
export const VisualPreset = /* @__PURE__ */ forwardRef<
  HTMLImageElement,
  EmptyStateVisualPresetProps
>((props, forwardedRef) => {
  const {
    context,
    type,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;

  const currentTheme = useCurrentTheme();
  const visualPresetUrl = useVisualPresetCdnUrl(context, type, currentTheme);

  return (
    <img
      // no meaningful alt text for screen readers
      aria-hidden
      alt=""
      ref={forwardedRef}
      src={visualPresetUrl}
      className={consumerClassName}
      style={consumerStyle}
      data-testid={dataTestId}
    />
  );
});

(VisualPreset as typeof VisualPreset & { displayName: string }).displayName =
  'EmptyState.VisualPreset';
